// extracted by mini-css-extract-plugin
export default {"linkLernMore":"Holidayheader_linkLernMore__mp5QY","textStyle":"Holidayheader_textStyle__cmRCy","backGroundColor":"Holidayheader_backGroundColor__xGX1q"};